import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { renderIf } from 'modules/render-if';
import InputField from '../Input';
import Field, { formatValueToTemplate } from 'shared-components/FormFields/helpers';

const VALID_CHAR_REGEX = /\d/;

const wildcardsCount = (template, wildcards) => {
  const wildRegex = new RegExp(`[${wildcards}]`, "g");
  return template.match(wildRegex).length;
};

class NumberWithTemplate extends Component {

  state = {
    displayValue: "",
    value: "",
    keycode: undefined,
    selectionStart: 0,
  }

  componentWillMount() {
    const { maxLength, wildcardChars } = this.props;
    const { defaultValue, placeholder } = this.props.input;

    if (!!defaultValue) {
      const rawValue = Field.removeNonDigits(defaultValue);
      const maxLength = wildcardsCount(placeholder, wildcardChars);
      const defaultDisplayValue = formatValueToTemplate(Field.truncate(rawValue, maxLength), placeholder, wildcardChars);
      this.setState({ displayValue: defaultDisplayValue });
    }
  }

  onBlur = (e, val) => {
    if (this.props.onBlur) {
      this.props.onBlur(e, val);
    }
  }

  onFocus = (e) => {
    if (this.props.onFocus) this.props.onFocus(e);
  }

  onKeyDown = (e) => {
    const { selectionStart, selectionEnd } = e.target;
    this.setState({ keycode: e.keyCode, selectionStart });
  }

  onInput = (e, val) => {
    const placeholder = this.props.input.placeholder;
    const {
      value: lastValue,
      displayValue: lastDisplayValue,
      selectionStart,
      keycode,
    } = this.state;
    const maxLength = wildcardsCount(placeholder, this.props.wildcardChars);

    const value = Field.calculateNewValue({
      lastVal: lastValue,
      currVal: Field.removeNonDigits(val),
      selectStart: selectionStart,
      lastDisplayValue,
      keycode,
      maxLength,
      validCharRegex: VALID_CHAR_REGEX,
    });

    const displayValue = formatValueToTemplate(Field.truncate(value, maxLength), placeholder, this.props.wildcardChars);

    if (selectionStart !== lastDisplayValue.length) {
      const cursorPos = Field.nextSelectionPosition({
        selectStart: selectionStart,
        lastDisplayValue,
        currDisplayValue: displayValue,
        keycode,
        validCharRegex: VALID_CHAR_REGEX,
      });

      const _input = e.target;
      setTimeout(() => {
        _input.setSelectionRange(cursorPos, cursorPos);
      }, 0);
    }

    this.setState({
      displayValue,
      value,
    });
  }

  render() {
    const {
      label,
      className,
      isRequired
    } = this.props;

    const fieldProps = {
      ...this.props,
      type: "tel",
      input: {
        ...this.props.input,
        value: this.state.displayValue,
      },
      onBlur: this.onBlur,
      onFocus: this.onFocus,
      onInput: this.onInput,
      onKeyDown: this.onKeyDown,
    };

    return (
      <InputField { ...fieldProps } />
    );
  }
}

NumberWithTemplate.propTypes = {
  label: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    defaultValue: PropTypes.string,
  }),
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  wildcardChars: PropTypes.string.isRequired,
};

export default NumberWithTemplate;
